import { useState } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { getAcceptTermsText, logException } from 'Utils';
import { withLogin } from 'Components/hocs';
import ProgressBar from 'Components/ProgressBar';
import TermsPanel from 'Components/TermsPanel';

const TermsAndConditions = (props) => {
  const [submitting, setSubmitting] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [existingUser, setExistingUser] = useState(true);
  const [registrationItems, setRegistrationItems] = useState({
    ...props.registrationItems,
  });

  const checkExistingUser = async () => {
    const existingUser = await props.uim.isExistingAccount();
    setExistingUser(existingUser);
  };

  const setConsentValidity = (valid, registrationItems) => {
    setIsValid(valid);
    setRegistrationItems(registrationItems);
  };

  const updateUserConsents = async () => {
    // Submit missing user consents
    try {
      const selected = props.uim.getSelectedRegistrationItems(
        registrationItems
      );
      await props.uim.uimApi.submitMandatoryAndNewsletterInformation(
        {}, // Empty fields since we're not updating that
        selected.policies,
        selected.newsletters
      );
      props.redirect();
    } catch (err) {
      logException(err);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitting(true);
    updateUserConsents();
  };

  checkExistingUser();

  if (_isEmpty(registrationItems)) return <ProgressBar />;

  return (
    <div>
      {submitting && <ProgressBar />}
      <form onSubmit={handleSubmit}>
        <h1 className="page-heading">{props.strings.termsAndConditions}</h1>
        <TermsPanel
          disabled={submitting}
          locale={props.locale}
          registrationItems={registrationItems}
          setConsentValidity={setConsentValidity}
          uim={props.uim}
        />
        <button type="submit" disabled={!isValid || submitting}>
          {getAcceptTermsText(props.strings, props.country, existingUser)}
        </button>
      </form>
    </div>
  );
};

TermsAndConditions.propTypes = {
  country: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  redirect: PropTypes.func.isRequired,
  registrationItems: PropTypes.object.isRequired,
  strings: PropTypes.object.isRequired,
  uim: PropTypes.object.isRequired,
};

export default withLogin(TermsAndConditions);
